import { render, staticRenderFns } from "./AddAccountError.vue?vue&type=template&id=ed41ba9a&"
import script from "./AddAccountError.vue?vue&type=script&lang=js&"
export * from "./AddAccountError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddAccountError.vue"
export default component.exports